module.exports = __webpack_public_path__ + "static/img/tcBanner.1ac6330.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/tcBanner.jpg
// module id = IWp1
// module chunks = 1